import {
  CashMovementDetailParams,
  CashMovementDetailResponse,
  CashMovementProductType,
} from '@repo/accounts-types'
import { Service } from '@repo/core'

const productTypeUrlMap: Record<CashMovementProductType, string> = {
  CASH: 'cash-accounts',
  CREDIT: 'credits',
}

export const getCashMovementDetail: Service<
  CashMovementDetailParams,
  CashMovementDetailResponse
> = async ({ api, params }) => {
  const { productType, id, movementId } = params

  return api.get<CashMovementDetailResponse>(
    `/accounts/${productTypeUrlMap[productType]}/${id}/movements/${movementId}`,
  )
}
